// extracted by mini-css-extract-plugin
module.exports = {"cancelSubmitButtonsWrapper":"styles_cancelSubmitButtonsWrapper__1hvtP","buttonsParent":"styles_buttonsParent__3i5Et","Button":"styles_Button__1qLIc"};